export default __webpack_public_path__ + "website-sdk@2x.png";